import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-layout">
            <div className="hero-content">
              <span className="hero-label">The Ethical AI Archive</span>
              <h1 className="hero-title">
                Content that consents to AI training
              </h1>
            </div>
            <div className="hero-aside">
              <p className="hero-description">
                We crawl the web for content with explicit consent signals. 
                Every piece is traced to its source with full attribution, 
                building a foundation for responsible AI development.
              </p>
              <div className="hero-actions">
                <Link to="/search" className="btn btn-primary">
                  Search the Index
                  <span className="arrow-icon">&rarr;</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Principles Section */}
      <section className="principles">
        <div className="container">
          <div className="principles-header">
            <span className="section-label">Our Approach</span>
            <h2 className="section-title">Building AI that respects creators</h2>
          </div>
          
          <div className="principles-grid">
            <article className="principle">
              <span className="principle-number">01</span>
              <h3 className="principle-title">Consent-Based</h3>
              <p className="principle-description">
                We only index content with explicit consent signals: Content Signals 
                directives, Creative Commons licenses, or direct opt-ins. No scraping 
                without permission.
              </p>
            </article>
            
            <article className="principle">
              <span className="principle-number">02</span>
              <h3 className="principle-title">Full Attribution</h3>
              <p className="principle-description">
                Every piece of content includes source URL, author, license, 
                and suggested citation format. Credit flows back to creators.
              </p>
            </article>
            
            <article className="principle">
              <span className="principle-number">03</span>
              <h3 className="principle-title">Easy Removal</h3>
              <p className="principle-description">
                Content owners can request removal at any time. We respect your 
                right to control your work, no questions asked.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="process">
        <div className="container">
          <div className="process-header">
            <span className="section-label">The Process</span>
            <h2 className="section-title">From consent to contribution</h2>
          </div>
          
          <div className="process-steps">
            <div className="process-step">
              <div className="step-marker">
                <span className="step-number">1</span>
              </div>
              <div className="step-content">
                <h4 className="step-title">We Check for Consent</h4>
                <p className="step-description">
                  Our crawler looks for Content-Signal directives in robots.txt 
                  and Creative Commons licenses in page metadata. Only consented 
                  content proceeds.
                </p>
              </div>
            </div>
            
            <div className="process-step">
              <div className="step-marker">
                <span className="step-number">2</span>
              </div>
              <div className="step-content">
                <h4 className="step-title">We Index with Attribution</h4>
                <p className="step-description">
                  Approved content is stored with full provenance: author, license, 
                  source URL, and timestamp. Every piece maintains its connection 
                  to its creator.
                </p>
              </div>
            </div>
            
            <div className="process-step">
              <div className="step-marker">
                <span className="step-number">3</span>
              </div>
              <div className="step-content">
                <h4 className="step-title">AI Tools Query Ethically</h4>
                <p className="step-description">
                  Developers can search our index via API or MCP, knowing all 
                  content is ethically sourced with proper attribution.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <div className="cta-layout">
            <div className="cta-content">
              <span className="section-label">Get Involved</span>
              <h2 className="cta-title">Want your content included?</h2>
              <p className="cta-description">
                Add Content Signals to your robots.txt or register your site directly. 
                Join the growing network of creators building ethical AI.
              </p>
            </div>
            
            <div className="cta-code-block">
              <div className="code-header">
                <span className="code-filename">robots.txt</span>
              </div>
              <pre className="code-content"><code>User-agent: *
Allow: /

# Content Signals for AI
Content-Signal: search=yes, ai-train=yes</code></pre>
            </div>
          </div>
          
          <div className="cta-actions">
            <a 
              href="https://contentsignals.org" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-secondary"
            >
              Learn About Content Signals
              <span className="arrow-icon">&rarr;</span>
            </a>
            <Link to="/register" className="btn btn-primary">
              Register Your Site
              <span className="arrow-icon">&rarr;</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Stats Section (Optional Visual Interest) */}
      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat">
              <span className="stat-number">129</span>
              <span className="stat-label">Domains Indexed</span>
            </div>
            <div className="stat">
              <span className="stat-number">4</span>
              <span className="stat-label">Content Categories</span>
            </div>
            <div className="stat">
              <span className="stat-number">100%</span>
              <span className="stat-label">Consent-Based</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
